import React, { Component } from "react";
const d3 = require("d3");

class MatrixBarGraph extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.drawBarGraph(this.props.data);
    this.forceUpdate();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.drawBarGraph(this.props.data);
  }

  drawBarGraph(data) {
    /* transform data */
    data = [data.single, data.over, data.miss];

    d3.select(".matrix-bar-graph")
      .selectAll("*")
      .remove();

    var width = 300,
      barHeight = 20;

    var x = d3
      .scaleLinear()
      .domain([0, d3.max(data)])
      .range([0, width]);

    var chart = d3
      .select(".matrix-bar-graph")
      .attr("width", width)
      .attr("height", barHeight * data.length);

    var bar = chart
      .selectAll("g")
      .data(data)
      .enter()
      .append("g")
      .attr("transform", function(d, i) {
        return "translate(0," + i * barHeight + ")";
      });

    bar
      .append("rect")
      .attr("width", d => Math.max(x(d), 2))
      .attr("fill", (d, i) => ["#7c7", "#efb03b", "#c77"][i])
      .attr("height", barHeight - 1);

    bar
      .append("text")
      .attr("x", function(d) {
        return x(d) - 3;
      })
      .attr("y", barHeight / 2)
      .attr("dy", ".35em")
      .text(function(d) {
        return d;
      });
  }

  render() {
    return <svg className="matrix-bar-graph" />;
  }
}

export default MatrixBarGraph;
